<template>
    <div class="welcome">
        <div class="welcome-group">
            <img src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png" class="portia" />
            <div>
                <p class="title">欢迎您 {{userInfo.name}} 工作加油哦</p>
                <p class="desc">当前时间：{{time}}</p>
            </div>
        </div>
        <div class="quickly">
            <!-- <h1 class="title">操作平台快接入口</h1> -->
            <div class="btnList">
                <Permission allowed="user.factor-admins.list">
                    <router-link to="/user/factor-admin/list" class='items'>
                        <div class="round">
                            <img src="../../assets/img/admin.png" />
                        </div>
                        <span class="name">代理商超管列表</span>
                    </router-link>
                </Permission>
                <Permission allowed="business.factor.list">
                    <router-link to="/business/agent/list" class='items'>
                        <div class="round round-1">
                            <img src="../../assets/img/user.png" />
                        </div>
                        <span class="name">代理商列表</span>
                    </router-link>
                </Permission>
                <Permission allowed="business.balance.list">
                    <router-link to="/business/balance/list" class='items'>
                        <div class="round round-2">
                            <img src="../../assets/img/store.png" />
                        </div>
                        <span class="name">充值与消费明细</span>
                    </router-link>
                </Permission>
                <Permission allowed="business.sites.add">
                    <router-link to="/business/site/add" class='items'>
                        <div class="round round-3">
                            <img src="../../assets/img/site.png" />
                        </div>
                        <span class="name">新建站点</span>
                    </router-link>
                </Permission>
                <Permission allowed="data.customers.list">
                    <router-link to="/data/customers/list" class='items'>
                        <div class="round round-4">
                            <img src="../../assets/img/clue.png" />
                        </div>
                        <span class="name">查看客户线索</span>
                    </router-link>
                </Permission>
                <Permission allowed="data.call-record.list">
                    <router-link to="/data/phone/list" class='items'>
                        <div class="round round-5">
                            <img src="../../assets/img/phone.png" />
                        </div>
                        <span class="name">查看400通话记录</span>
                    </router-link>
                </Permission>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { parseTime } from '@/utils/index'
export default {
    name: 'Welcome',
    computed: {
        ...mapState('user', {
            userInfo: 'userInfo'
        })
    },
    data () {
        return {
            time: parseTime(new Date(), '{y}年{m}月{d}日 {h}:{i} 星期{a}')
        }
    },
    mounted () {
        console.log(this.$store.state.user.userInfo.role_id)
        setInterval(() => {
            this.time = parseTime(new Date(), '{y}年{m}月{d}日 {h}:{i} 星期{a}')
        }, 1000)
    }
}
</script>
<style scoped lang="less">
.welcome{
    .welcome-group{
        padding: 50px;
        display: -webkit-box;
        -webkit-box-align: center;
        .portia{
            width: 72px;
            height: 72px;
            border-radius: 50%;
            display: block;
            object-fit: cover;
        }
        .title{
            margin-bottom: 8px;
            color: rgba(0,0,0,.85);
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            margin-left: 15px;
        }
        .desc{
            margin-left: 15px;
            color: #00000073;
            line-height: 22px;
            font-size: 14px;
        }
    }
    .quickly{
        margin: 50px;
        .title{
            font-size: 20px;
            color: rgba(0, 0, 0, 0.85);
        }
        .btnList{
            display: flex;
            margin-top: 30px;
            -webkit-box-pack: center;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            max-width: 1100px;
            margin: 0 auto;
            .items{
                width: 280px;
                height: 150px;
                border-radius: 10px;
                text-align: center;
                background: #ffffff;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-box-align: center;
                -webkit-box-pack: center;
                margin-right: 30px;
                margin-bottom: 30px;
                text-decoration: none;
                transition: all linear 0.3s;
                &:hover{
                    transform: scale(1.03);
                }
                .round{
                    width: 60px;
                    height: 60px;
                    background: #60b4fa;
                    border-radius: 50%;
                    overflow: hidden;
                    text-align: center;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-box-align: center;
                    -webkit-box-pack: center;
                    img{
                        width: 35px;
                        display: block;
                    }
                }
                .round-1{
                    background: #a991f3;
                }
                .round-2{
                    background: #fdcc53;
                }
                .round-3{
                    background: #21cfb8;
                }
                .round-4{
                    background: #5bc4f1;
                }
                .round-5{
                    background: #f9af66;
                }
                .name{
                    display: block;
                    margin-top: 10px;
                    color: #1f1f1f;
                    font-size: 16px;
                }
            }
        }
    }
}
</style>